import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import { ThemeModeContext } from '~theme-provider';
import Container from './Label/Container';
import Label from './Label/Label';
import buttonPropTypes from '../prop-types/buttonPropTypes';
import buttonStyles from '../styles/buttonStyles';
var LinkButtonBase = styled(Link).withConfig({
  displayName: "LinkButton__LinkButtonBase",
  componentId: "hp7uli-0"
})(["&,&:hover{text-decoration:none;}", ""], function (_ref) {
  var $block = _ref.$block;
  return $block && css(["display:block;width:100%;"]);
});
var Button = styled.span.withConfig({
  displayName: "LinkButton__Button",
  componentId: "hp7uli-1"
})(["", ""], buttonStyles);

var LinkButton = function LinkButton(_ref2) {
  var icon = _ref2.icon,
      iconSize = _ref2.iconSize,
      iconColor = _ref2.iconColor,
      skin = _ref2.skin,
      size = _ref2.size,
      block = _ref2.block,
      to = _ref2.to,
      btnType = _ref2.btnType,
      children = _ref2.children,
      isActive = _ref2.isActive,
      props = _objectWithoutPropertiesLoose(_ref2, ["icon", "iconSize", "iconColor", "skin", "size", "block", "to", "btnType", "children", "isActive"]);

  var _useContext = useContext(ThemeModeContext),
      themeMode = _useContext.themeMode;

  var buttonContent = icon ? /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Label, {
    icon: icon,
    size: iconSize,
    color: iconColor,
    btnSize: size,
    skin: skin
  }, children)) : children;
  return /*#__PURE__*/React.createElement(LinkButtonBase, Object.assign({
    to: to,
    $block: block
  }, props), /*#__PURE__*/React.createElement(Button, {
    sizeValue: size,
    blockValue: block,
    skin: skin,
    btnType: btnType,
    isActive: isActive,
    themeMode: themeMode
  }, buttonContent));
};

LinkButton.defaultProps = {
  skin: 'primary',
  size: 'default',
  btnType: 'default',
  icon: undefined,
  iconColor: 'currentColor',
  iconSize: undefined,
  block: false,
  children: undefined,
  isActive: false
};
export default LinkButton;